<template>
    <div id="app">
      <el-row class="logos" style="float: left;">
        <img src="@/assets/logo.png">
       
        <div>使用项目前请设计打印😁</div>
      </el-row >
      <el-row type="flex" class="menus">
        <el-button-group>
          <template v-for="demo in demoList">
            <el-button :key="demo.name" :type="demo.name === curDemo ? 'primary' : 'info'" @click="curDemo = demo.name">
              {{ demo.title }}
            </el-button>
          </template>
        </el-button-group>
        <div style="margin-left: 20px"/>
        <el-button style="width:30vw;font-size: 16px;" :type="'templates' === curDemo ? 'primary' : 'info'"
                  icon="file-search"
                  @click="curDemo = 'templates'">
          关联表单
        </el-button>
      </el-row>
      <!-- 动态渲染组件，懒得去弄路由了 -->
      <keep-alive>
        <component :is="curDemo"/>
      </keep-alive>
    </div>
  </template>
  
  <script>
  
  import printDesign from './design/index'
  import printCustom from './custom/index'
  import printTasks from './tasks/index'
  import printPanels from './panels/index'
  import templates from './templates/index'
  
  export default {
    name: 'App',
    components: {printDesign, printCustom, printTasks, printPanels, templates},
    data() {
      return {
        curDemo: 'printDesign',
        demoList: [
          {name: 'printDesign', title: '默认拖拽设计'},
          {name: 'printCustom', title: '自定义设计'},
          {name: 'printTasks', title: '队列/批量打印'},
          {name: 'printPanels', title: '多面板设计'}
        ]
      }
    },
  }
  </script>
  
  <style lang="less">
  .logos {
    padding: 6px 24px;
    display: flex;
    justify-content: center;
    align-self: center;
  
    img {
      height: 40px;
      width: 40px;
    }
  }
  
  .menus {
    padding: 10px 24px;
  }
  
  // hiprint 拖拽图片
  .hiprint-printElement-image-content {
    img {
      content: url("~@/assets/logo.png");
    }
  }
  
  // 修改 页眉/页脚线 样式
  .hiprint-headerLine, .hiprint-footerLine {
    border-color: red !important;
  }
  
  .hiprint-headerLine:hover, .hiprint-footerLine:hover {
    border-top: 3px dashed red !important;
  }
  
  .hiprint-headerLine:hover:before {
    content: "页眉线";
    left: calc(50% - 18px);
    position: relative;
    background: #FFFF;
    top: -12px;
    color: red;
    font-size: 12px;
  }
  
  .hiprint-footerLine:hover:before {
    content: "页脚线";
    left: calc(50% - 18px);
    position: relative;
    color: red;
    background: #FFFF;
    top: -12px;
    font-size: 12px;
  }
  </style>
  